module.exports = __webpack_public_path__ + "static/media/emina_home_banner.88851c12.jpg";